import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import cronJobsService from '../services/cronJobsService';
import { queryKeys } from './queryKeys';

export function useCronJobs(options = {}) {
  return useQuery({
    queryKey: queryKeys.cronJobs.all,
    queryFn: () => cronJobsService.getAllJobs(),
    staleTime: Infinity,
    ...options,
  });
}

export function useDeleteCronJob(options = {}) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: id => cronJobsService.deleteJob(id),
    onSuccess: (...args) => {
      queryClient.invalidateQueries({ queryKey: queryKeys.cronJobs.all });
      options.onSuccess?.(...args);
    },
    onError: options.onError,
  });
}

export function useUpdateCronJob(options = {}) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: payload => cronJobsService.updateJob(payload),
    onSuccess: (...args) => {
      queryClient.invalidateQueries({ queryKey: queryKeys.cronJobs.all });
      options.onSuccess?.(...args);
    },
    onError: options.onError,
  });
}

export function useCreateCronJob(options = {}) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: payload => cronJobsService.createJob(payload),
    onSuccess: (...args) => {
      queryClient.invalidateQueries({ queryKey: queryKeys.cronJobs.all });
      options.onSuccess?.(...args);
    },
    onError: options.onError,
  });
}
